export default __webpack_public_path__ + "static/media/Flash-Survey-Logo-White.1dd51ac2.svg";